import { CallStatus } from '@/types';

export const CallStatusColorMap = {
    [CallStatus.ANSWERED]: '#B9F6D1',
    [CallStatus.NO_ANSWER]: '#EDC7CD',
    [CallStatus.BUSY]: '#F2EC8F',
    [CallStatus.DITCHED]: '#CFE2F1',
};
